import type {
  UsageResponse,
  UsageRollupsResponse,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const usageApi = {
  current() {
    return request<UsageResponse>("/admin/usage", {
      query: { period: "current_month" },
    });
  },
  rollups(query: { from?: string; to?: string } = {}) {
    return request<UsageRollupsResponse>("/admin/usage/rollups", { query });
  },
};
